// extracted by mini-css-extract-plugin
export default {"alert":"oWQ+P"};